<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-07 18:09:11
 * @FilePath: \mrc-base-frontend\src\views\pushMessageTopic\modules\relaship.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-10 11:20:48
-->
<template>
  <mrc_ess_table
    :headers="headers"
    :hideAddBtn="true"
    class="elevation-0"
    :paginationOptions="options"
    @turnPage="getRelaMap"
    style="border: 1px solid rgba(0, 0, 0, 0.15)"
    :isLoading="loading"
    :slotKey="['preferred_name']"
    :items="desserts"
    hide-default-footer
  >
    <template #item.preferred_name="{ item }">
      <span>{{ INT(item.preferred_name) }}</span>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn v-show="!disabled" icon elevation="0" @click.stop="delItem(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
  </mrc_ess_table>
</template>
<script>
import { getMessageTopicMap } from "@/service/api/pushMessageTopic";
export default {
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      desserts: [],
      loading: false,
      options: {
        pagesize: 5, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
        selectlist: [10, 20, 50, 100, 200],
        pagetext: this.$t("label_Each_page_shows"),
      },
    };
  },
  watch: {},
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_staff_code"),
          align: "start",
          value: "staff_code",
          sortable: false,
        },
        {
          text: this.$t("label_username"),
          align: "start",
          value: "preferred_name",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ];
    },
  },
  mounted() {
    this.getRelaMap();
  },
  methods: {
    delItem(item) {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      }).then((res) => {
        this.$emit("delete", item.uuid);
        this.desserts = this.desserts.filter((ele) => ele.uuid !== item.uuid);
      });
    },
    turnPage({ cpage, pagesize }) {
      this.options.cpage = cpage;
      this.options.pagesize = pagesize;
      this.getlist();
    },
    async getRelaMap(obj) {
      this.loading = true;
      if (this.desserts.length == 1 && this.options.cpage != 1)
        this.options.cpage--;
      if (obj) {
        const { cpage, pagesize } = obj;

        this.options = { ...this.options, ...obj };
      }
      const res = await getMessageTopicMap({
        topic_uuid: this.$store.state.uuid,
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      if (res.code == 200) {
        this.desserts = res.data;
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
      }
      this.loading = false;
    },
  },
};
</script>